import { render, staticRenderFns } from "./LabelWithAnnotation.vue?vue&type=template&id=7639a304&scoped=true"
import script from "./LabelWithAnnotation.vue?vue&type=script&lang=ts"
export * from "./LabelWithAnnotation.vue?vue&type=script&lang=ts"
import style0 from "./LabelWithAnnotation.vue?vue&type=style&index=0&id=7639a304&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7639a304",
  null
  
)

export default component.exports